import { Trans } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import Paragraph from '@/design_system/Typography/Paragraph';
import { useBrands } from '@/models/brand';
import { useSettingsScope } from '@/routes/SettingsBeta/SettingsContext';

import { type ConditionFormQuestion } from '../ConditionQuestion';

export const BrandsReadOnly = ({ question }: { question: ConditionFormQuestion }) => {
  const { scope } = useSettingsScope();
  const organizationId = scope?.scope === 'organization' ? scope.organizationId : undefined;
  const { data: { brands: organizationBrands = [] } = {} } = useBrands({
    organizationId,
    limit: 2,
    offset: 0,
  });

  const isMultiBrand = organizationBrands.length > 1;

  if (isMultiBrand) {
    return (
      <Paragraph>
        <Trans id="settings.organization.data-catalogs.condition-forms.detail.question.brands">
          Brands:{' '}
        </Trans>
        <InlineText weight="medium">
          {question.brands.length > 0 ? (
            question.brands.map((brand) => brand.name).join(', ')
          ) : (
            <Trans id="settings.organization.data-catalogs.condition-forms.detail.question.all-brands">
              All
            </Trans>
          )}
        </InlineText>
      </Paragraph>
    );
  }
};
